const annuncioReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ANNUNCIO': {
            let newState = {...state}
            newState.annuncio = action.annuncio
            return state = newState
        }
        case 'SET_STATE_ANNUNCIO': {
            let newState = {...state}
            newState[action.id] = action.stateAnnuncio
            return state = newState
        }
        case 'DELETE_ANNUNCIO': {
            return state = {}
        }
        default:
            return state
    }
}

export default annuncioReducer
